    /**
    * pages.phonepayment Module
    *
    * Description
    */
    var app = angular.module('directives.sliderServices');

    app.factory('OneClickPayment', ['$http', function ($http) {
        var factory = {
            oneClickPayment: [],
            phoneCode: [],
            doOneClickPayment: function (payment) {
                var flag = true;

                if (payment.cardA && payment.cardB) {
                    payment.cardA = payment.cardA.replace(/[^\*\d]/g,'');
                    payment.cardB = payment.cardB.replace(/[^\*\d]/g,'');
                }

                this.oneClickPayment = payment;

                if (payment.phone) {
                    this.oneClickPayment.serviceId = this.phoneCodeFinder(payment.phone);

                    if (!this.oneClickPayment.serviceId) {
                        flag = false;
                        alert('Оператор сотовой связи не идентифицирован 333');
                    }
                }
                return flag;
            },

            phoneCodeFinder: function (phone) {

                var phoneCode = phone.toString().replace(/[^\d]/g, '').substr(0, 3);
                var self = this;

                self.oneClickPayment.operator = void 0;

                self.phonesTypes.forEach(function (operator) {

                    if (operator.numbers.indexOf(phoneCode) !== -1) {
                        self.oneClickPayment.operator = operator.id;
                    }
                });

                return !!this.oneClickPayment.operator;
            },

            phonesTypes: [
                //Dev
                //{id: 9579 , numbers: ['050', '066', '099']},
                //{id: 10074, numbers:['067', '098', '097']},
                //{id: 10052, numbers:['063', '093']}

                //Prod
                {id: 12127 , numbers: ['050', '066', '099']},
                {id: 12717, numbers:['067', '098', '097']},
                {id: 12674, numbers:['063', '093']}

            ]
        };

        return factory;

    }]);

    // module.bleat = app;  


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServices/services/oneclickpayment.factory.js
 ** module id = 227
 ** module chunks = 1
 **/